import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { NotificationService } from 'src/app/core/notification.service'
import {
  AvailableCountry,
  TranslatorService
} from 'src/app/core/translator.service'

@Component({
  selector: 'configuration-option-other-card',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionOtherCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues: any

  public isLoading$: Observable<boolean>
  public availableCountries: AvailableCountry[]
  public isCollapsed = false
  public accessRights = AccessRights
  public form: UntypedFormGroup
  public environment = environment

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private translatorService: TranslatorService
  ) {}

  ngOnInit() {
    this.availableCountries = this.translatorService.availableCountries

    this.form = this.fb.group({
      adminemail: ['', []],
      default_country: ['', []],
      create_sale_cancel_notification: [false, []]
    })

    this.form.controls.adminemail.patchValue(this.formValues.adminemail)
    this.form.controls.default_country.patchValue(
      this.formValues.default_country
    )
    this.form.controls.create_sale_cancel_notification.patchValue(
      this.formValues.create_sale_cancel_notification
    )
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }

    this.onSubmit.emit(this.form.value)
  }
}
